import {
  Box,
  Checkbox,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import CustomPagination from "../../../../components/Common/CustomPagination";

const CargoList = ({
  cargoContracts,
  onChangeCargoPagination,
  cargoFilters,
  contractType,
  onClickCargo,
  selectedCargo,
  isLoading,
  modelType,
  onViewCargo,
}) => {
  const handleCheckboxChange = (cargo) => {
    const newSelection =
      selectedCargo && selectedCargo._id === cargo._id ? null : cargo;
    onClickCargo(newSelection);
  };

  const normalizedList = Array.isArray(cargoContracts)
    ? cargoContracts.map((item) => {
      const isContract = !!item.contractType || !!item?.contractName;

      if (isContract) {
        const cargoDetails = item?.cargoDetails || {};
        const firstPort = cargoDetails?.customerCargo?.cargoList?.[0]?.port || cargoDetails?.cargoList?.[0]?.port;
        const lastPort = cargoDetails?.customerCargo?.cargoList?.[
          cargoDetails?.customerCargo?.cargoList?.length - 1
        ]?.port || cargoDetails?.cargoList?.[cargoDetails?.cargoList?.length - 1]
            ?.port;

        return {
          _id: item._id,
          isContract: true,
          contractName: item.contractName,
          cargoName: cargoDetails?.name || "-",
          firstPort: firstPort || "-",
          lastPort: lastPort || "-",
          cpDate: item.cpDate,
          counterparty: item.counterpartyFullStyle,
          contractingCompany: item.contractingCompany,
          status: item.status,
          raw: item,
        };
      } else {
        return {
          _id: item._id,
          isContract: false,
          freightMode: item.freightMode || "-",
          cargoName: item.name || "-",
          firstPort: item.cargoList?.[0]?.port || "-",
          lastPort: item.cargoList?.[item.cargoList?.length - 1]?.port || "-",
          cpDate: item.laycanStartDate || item.createdAt || null,
          status: "active",
          raw: item,
        };
      }
    })
    : [];

  // ✅ Filter for contracts only when needed
  const filteredCargos = normalizedList.filter((cargo) => {
    if (
      cargo.isContract &&
      ((cargo.raw.contractType === "cargo-cargo" &&
        modelType === "vessel-cargo") ||
        cargo.status === "close")
    ) {
      return false;
    }
    return true;
  });

  return (
    <Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" padding={4}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer
            component={Paper}
            className="scroll-thin"
            style={{ maxHeight: "500px", overflow: "auto" }}
          >
            {cargoFilters.totalItems > cargoFilters.limit && (
              <CustomPagination
                onChangePagination={onChangeCargoPagination}
                filters={cargoFilters}
                totalPage={cargoFilters.totalItems}
              />
            )}

            <Table className="universal-table contract-estimate-selection-table fit-content-mobile" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Select</TableCell>
                  {modelType !== "vessel" && contractType !== "cargo-cargo" && (
                    <TableCell>Contract Name</TableCell>
                  )}
                  {(modelType === "vessel" ||
                    contractType === "cargo-cargo") && (
                      <TableCell>freight Mode</TableCell>
                    )}
                  <TableCell>Cargo Name</TableCell>
                  <TableCell>First Load Port</TableCell>
                  <TableCell>Last Discharge Port</TableCell>
                  <TableCell>CP / Created Date</TableCell>
                  {modelType !== "vessel" && contractType !== "cargo-cargo" && (
                    <>
                      <TableCell>Counter Party</TableCell>
                      <TableCell>Contracting Company</TableCell>
                    </>
                  )}
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredCargos.length > 0 ? (
                  filteredCargos.map((cargo) => {
                    const isSelected =
                      selectedCargo && selectedCargo._id === cargo._id;

                    return (
                      <TableRow
                        key={cargo._id}
                        hover
                        className={isSelected ? "contract-estimate-selected" : ""}
                        onClick={() => handleCheckboxChange(cargo.raw)}
                        tabIndex={0}
                        aria-selected={Boolean(isSelected)}
                        onKeyDown={(event) => {
                          if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) {
                            event.preventDefault();
                            handleCheckboxChange(cargo.raw);
                          }
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isSelected}
                            color="primary"
                            style={{ color: isSelected ? "#313C4C" : "#64748b" }}
                            onChange={() => handleCheckboxChange(cargo.raw)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </TableCell>
                        {modelType !== "vessel" &&
                          contractType !== "cargo-cargo" && (
                            <TableCell>{cargo.contractName || "-"}</TableCell>
                          )}
                        {(modelType === "vessel" ||
                          contractType === "cargo-cargo") && (
                            <TableCell>{cargo.freightMode || "-"}</TableCell>
                          )}
                        <TableCell>{cargo.cargoName || "-"}</TableCell>
                        <TableCell>{cargo.firstPort || "-"}</TableCell>
                        <TableCell>{cargo.lastPort || "-"}</TableCell>
                        <TableCell>
                          {cargo.cpDate
                            ? moment(cargo.cpDate).format("DD-MM-YYYY")
                            : "-"}
                        </TableCell>
                        {modelType !== "vessel" &&
                          contractType !== "cargo-cargo" && (
                            <>
                              <TableCell>{cargo.counterparty || "-"}</TableCell>
                              <TableCell>
                                {cargo.contractingCompany || "-"}
                              </TableCell>
                            </>
                          )}
                        <TableCell>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (typeof onViewCargo === "function") {
                                onViewCargo(cargo.raw);
                              }
                            }}
                            style={{
                              color: "#2563eb",
                              background: "none",
                              border: "none",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontSize: "11px",
                              fontWeight: 500,
                              padding: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                            View Contract
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Typography variant="body1" color="textSecondary">
                        {!cargoContracts?.length
                          ? "No cargo data available"
                          : "No cargos match the current criteria"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {cargoFilters.totalItems > cargoFilters.limit && (
              <CustomPagination
                onChangePagination={onChangeCargoPagination}
                filters={cargoFilters}
                totalPage={cargoFilters.totalItems}
              />
            )}
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default CargoList;
